export * from './tracker-node';
export { default } from './tracker-node';
/*
 * this use case has not surfaced in any implementation:
 */
// export const defaultValue = () => {
//   const { timing } = (window.performance || {});
//   return {
//     performance: {
//       browser: timing ? timing.toJSON() : undefined,
//     },
//   };
// };
